import { render, staticRenderFns } from "./VisualMenu.vue?vue&type=template&id=3a4e8bf7&scoped=true"
import script from "./VisualMenu.js?vue&type=script&lang=js&external"
export * from "./VisualMenu.js?vue&type=script&lang=js&external"
import style0 from "./VisualMenu.scss?vue&type=style&index=0&id=3a4e8bf7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4e8bf7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLink: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Link/Link.vue').default})
